/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRefundRequest } from '../models/CreateRefundRequest';
import type { CreateRefundResponse } from '../models/CreateRefundResponse';
import type { CreateTopUpRequest } from '../models/CreateTopUpRequest';
import type { CreateTopUpResponse } from '../models/CreateTopUpResponse';
import type { LinkedIdentityListResponse } from '../models/LinkedIdentityListResponse';
import type { LinkTelegramIdentityRequest } from '../models/LinkTelegramIdentityRequest';
import type { LinkTelegramIdentityResponse } from '../models/LinkTelegramIdentityResponse';
import type { MeResponse } from '../models/MeResponse';
import type { MeStatsResponse } from '../models/MeStatsResponse';
import type { RedeemPromoCodeRequest } from '../models/RedeemPromoCodeRequest';
import type { RedeemPromoCodeResponse } from '../models/RedeemPromoCodeResponse';
import type { RefundRequestListResponse } from '../models/RefundRequestListResponse';
import type { UpdateLanguageRequest } from '../models/UpdateLanguageRequest';
import type { WalletTransactionsResponse } from '../models/WalletTransactionsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MeService {
    /**
     * Get current account profile
     * @returns MeResponse Current account profile
     * @throws ApiError
     */
    public static getApiV1Me(): CancelablePromise<MeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Update current account language
     * @returns MeResponse Updated current account profile
     * @throws ApiError
     */
    public static putApiV1MeLanguage({
        requestBody,
    }: {
        requestBody: UpdateLanguageRequest,
    }): CancelablePromise<MeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/me/language',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid language payload`,
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Redeem promo code for current account
     * @returns RedeemPromoCodeResponse Promo code redeemed
     * @throws ApiError
     */
    public static postApiV1MePromoCodesRedeem({
        requestBody,
    }: {
        requestBody: RedeemPromoCodeRequest,
    }): CancelablePromise<RedeemPromoCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/promo-codes/redeem',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid promo code payload or unavailable bot context`,
                401: `Unauthenticated`,
                409: `Promo code cannot be redeemed`,
            },
        });
    }
    /**
     * Create current account payment
     * @returns CreateTopUpResponse Payment checkout created
     * @throws ApiError
     */
    public static postApiV1MePayments({
        requestBody,
    }: {
        requestBody: CreateTopUpRequest,
    }): CancelablePromise<CreateTopUpResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid payment request`,
                401: `Unauthenticated`,
                500: `Payment creation failed`,
                503: `Payment provider unavailable`,
            },
        });
    }
    /**
     * Submit refund request for current account
     * @returns CreateRefundResponse Refund request submitted
     * @throws ApiError
     */
    public static postApiV1MeRefundRequests({
        requestBody,
    }: {
        requestBody: CreateRefundRequest,
    }): CancelablePromise<CreateRefundResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/refund-requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid refund request payload`,
                401: `Unauthenticated`,
                404: `Generation not found`,
                409: `Refund request cannot be submitted`,
            },
        });
    }
    /**
     * List refund requests for current account
     * @returns RefundRequestListResponse Refund requests
     * @throws ApiError
     */
    public static getApiV1MeRefundRequestsList(): CancelablePromise<RefundRequestListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/refund-requests/list',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * List current account wallet transactions
     * @returns WalletTransactionsResponse Wallet transaction history
     * @throws ApiError
     */
    public static getApiV1MeTransactions({
        limit,
        offset,
    }: {
        limit?: number,
        offset?: number,
    }): CancelablePromise<WalletTransactionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/transactions',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Get current account stats
     * @returns MeStatsResponse Current account generation and spend stats
     * @throws ApiError
     */
    public static getApiV1MeStats(): CancelablePromise<MeStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/stats',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * List identities linked to current account
     * @returns LinkedIdentityListResponse Linked identities
     * @throws ApiError
     */
    public static getApiV1MeIdentities(): CancelablePromise<LinkedIdentityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/identities',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Link Telegram identity to current account
     * @returns LinkTelegramIdentityResponse Telegram identity linked or merged
     * @throws ApiError
     */
    public static postApiV1MeIdentitiesTelegramLink({
        requestBody,
    }: {
        requestBody: LinkTelegramIdentityRequest,
    }): CancelablePromise<LinkTelegramIdentityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/identities/telegram/link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid Telegram auth payload or merge state`,
                401: `Unauthenticated`,
            },
        });
    }
}
